import { render, staticRenderFns } from "./GroupTeachers.vue?vue&type=template&id=923927ac&"
import script from "./GroupTeachers.vue?vue&type=script&lang=js&"
export * from "./GroupTeachers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports